import { render, staticRenderFns } from "./FormSearch.vue?vue&type=template&id=f2bbdefe&scoped=true&"
import script from "./FormSearch.vue?vue&type=script&lang=js&"
export * from "./FormSearch.vue?vue&type=script&lang=js&"
import style0 from "./FormSearch.vue?vue&type=style&index=0&id=f2bbdefe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bbdefe",
  null
  
)

export default component.exports